export const formatVolume = (volume, num = 5) => {
  if (!volume) return '-';
  const formatted = volume.toFixed(num);
  return formatted;
};

export default formatVolume;
